<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click="$emit('default', address)"
          class="mr-2"
          color="gray darken-2"
        >
          <v-icon
            small
            :color="(isDefault ? 'amber' : '')"
          >
            mdi-star
          </v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.datatable.headers.address }}</span>
    </v-tooltip>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="$emit('edit', address)"
          class="mr-2"
          color="gray darken-2"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="$emit('delete', address)"
          class="mr-2"
          color="gray darken-2"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    address: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  }
}
</script>
